<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-layout row wrap>
        <!-- <h3 style="width: 400px">*Defina a quatidade de solicitações de evidência:  </h3>
        <v-text-field
          v-model="tarefas_obrigatorias"
          :counter="3"
          label="Quantidade"
          required
          :rules="[v => !!v || 'Quantidade é obrigatória']"
          type="number"
          style="margin-top: -8px"
        ></v-text-field> -->
        <v-flex xs12>
        <h2 class="mb-1">Adicione Atividade</h2>

        <v-btn
            color="primary"
            @click="adicionar"
          >
            Adicionar
          </v-btn>
          <v-dialog id="dialog" v-model="dialog" max-width="100%" persistent>
          <v-card>
            <v-card-title> 
              <h1>Nova Atividade</h1>
            </v-card-title>
            <v-card-text>
              <v-text-field 
                label="Titulo da atividade" 
                ref="obs"
                hint="Exemplo: Aula 1"
                v-model="tarefatitulo"></v-text-field>
              <v-text-field 
                label="Descrição da atividade" 
                hint="Descreva o que necessita para realização da atividade"
                v-model="tarefadescricao"></v-text-field>
                <v-text-field 
                label="Objetivo da atividade" 
                hint="Descreva o objetivo"
                v-model="tarefaobjetivo"></v-text-field>
              </v-card-text>
            <v-card-actions>
              <input-criterios-aval 
                style="width: 100%"
                :criterios="criterios"
                :titulo="titulo"
                :clear="clear"
                :btnedit="btnedit"
                :editavel="editavel"
                :solicitacao="false"
                @saved="criteriosSelecionados"
                @edit="editAtual"
                @cancel="closeDialog"
              >
              </input-criterios-aval>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex style="widht: 100 %" xs12 class="mt-3" >
       <div v-if="!dialog" >
          <v-expansion-panel style="width: 100%" class="mt-2" v-for="tarefas in salvandoCriterio" :key="tarefas.obrigatorias">
            <v-expansion-panel-content >
              <div slot="header"> {{tarefas.title}}</div>
              <v-card raised tile >
                <v-card-title >
                <h2 style="text-align: center;" align-content-center> {{tarefas.title}}</h2>
                </v-card-title>
                <v-card-text>
                  <strong>Descrição:</strong> {{tarefas.description}}
                  <br>
                  <strong>Objetivo:</strong> {{tarefas.objetivo}}
                  </v-card-text>
                  <show-criterio
                  style="width: 100%"
                  :criterios="tarefas.habilidades_pks"
                  :titulo="false"
                  :solicitacao="false"
                  :botaosaved="false"
                  :btnedit="false">
                  </show-criterio>
                  <v-btn color="primary" flat @click.stop="editar(tarefas)">Editar atividade</v-btn>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
       </div>
      </v-flex>
      <v-flex xs12>
        <v-spacer></v-spacer>
        <v-layout align-center justify-end row fill-height>
          <div class="mt-5">
            <v-btn color="primary"  @click.native="$emit('prev')" >voltar</v-btn>
            <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>

</template>

<script>
// import api from '@/api'
import InputCriteriosAval from '@/components/reusable/inputCriteriosAval.vue'
import ShowCriterio from '@/components/reusable/showCriterio.vue'
export default {
  components: {
    InputCriteriosAval,
    ShowCriterio
  },
  props: [
    'step1Data',
    'criterios',
    'dialog_criterios',
    'habil'
  ],
  data () {
    return {
      result: {},
      tabela: false,
      habilidades_pks: [],
      tarefatitulo: '',
      tarefadescricao: '',
      tarefaobjetivo: '',
      tarefas_obrigatorias: '',
      show: false,
      salvandoCriterio: [],
      editavel: [],
      clear: true,
      i: 0,
      dialog: false,
      btnedit: false,
      options: {},
      valid: true,
      titulo: true,
      menu2: false
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    proximo () {
      if (this.$refs.form.validate()) {
        this.$emit('dados2', this.salvandoCriterio)
        this.$emit('dadotarefa', this.tarefas_obrigatorias)
        this.$emit('indicador')
        this.$emit('next')
      }
    },
    adicionar () {
      this.clear = true
      this.btnedit = false
      this.dialog = !this.dialog
    },
    criteriosSelecionados (value, close = true) {
      if (close) {
        this.dialog = false
      }
      this.salvandoCriterio[this.i] = {
        'habilidades_pks': value,
        'title': this.tarefatitulo,
        'description': this.tarefadescricao,
        'objetivo': this.tarefaobjetivo,
        'number': this.i
      }
      this.tarefatitulo = ''
      this.tarefadescricao = ''
      this.tarefaobjetivo = ''
      this.i = this.i + 1
      this.dialog = false
    },
    editar (value) {
      console.log('value', value)
      this.editavel = value
      this.tarefatitulo = value.title
      this.tarefadescricao = value.description
      this.tarefaobjetivo = value.objetivo
      this.btnedit = true
      this.dialog = true
    },
    editAtual (value) {
      this.salvandoCriterio[this.editavel.number].title = this.tarefatitulo
      this.salvandoCriterio[this.editavel.number].description = this.tarefadescricao
      this.salvandoCriterio[this.editavel.number].objetivo = this.tarefaobjetivo
      this.salvandoCriterio[this.editavel.number].habilidades_pks = value
      this.tarefatitulo = ''
      this.tarefadescricao = ''
      this.tarefaobjetivo = ''
      this.editavel = []
      this.dialog = false
    },
    closeDialog () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Padroes/CadastroSteps/Step2.vue